<script setup lang="ts">
const props = defineProps<{
  modelValue: boolean;
  isSubmitting: boolean;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: boolean];
  submit: [paymentMethodId: string];
}>();

function close() {
  emit('update:modelValue', false);
}

function handlePaymentCollected(paymentMethodId: string) {
  emit('submit', paymentMethodId);
}
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    max-width="520"
    :persistent="props.isSubmitting"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card>
      <v-card-title class="text-h6">Add Payment Method</v-card-title>
      <v-card-text>
        <ClientOnly>
          <StripePaymentMethodForm
            submit-label="Save Card"
            @payment-method-collected="handlePaymentCollected"
          />
        </ClientOnly>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" :disabled="props.isSubmitting" @click="close">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
